import type { PageContext } from "vike/types";

/**
 * Matches resource/blog paths: /resources, /resources/*, /tyoelama, /tyoelama/*, /arbetsliv, /arbetsliv/*
 * urlLogical is set by +onBeforeRoute (pathname without locale for resource paths).
 */
export function route(pageContext: PageContext): false | { routeParams: { pathLogical: string } } {
  const pathLogical =
    (pageContext as unknown as { urlLogical?: string }).urlLogical ??
    pageContext.urlPathname ??
    "";
  const normalized = pathLogical !== "/" ? pathLogical.replace(/\/$/, "") : pathLogical;
  const match = normalized.match(/^\/(resources|tyoelama|arbetsliv)(\/.*)?$/);
  if (!match) return false;
  return { routeParams: { pathLogical: normalized } };
}
